const saving_txt = Array.from(document.querySelectorAll(".savings_txt"));

//console.log(saving_txt);

const currencyFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0,
});

saving_txt.forEach(function (saving, i) {
  let saving_amt = saving.innerHTML;
  //console.log(saving_amt);

  const formatted_curr = currencyFormatter.format(saving_amt);
  console.log(formatted_curr);

  saving.innerHTML = formatted_curr;
});
